import { RESETS, FONTS } from './contants'

export const customReset = `
  ${RESETS};
  ${FONTS};
  
  /**
   * Best practice from http://callmenick.com/post/the-new-box-sizing-reset
   * TLDR: It’s easier to override and a slight performance boost.
   */
  *,
  *::before,
  *::after {
    box-sizing: inherit;
  }
  html {
    box-sizing: border-box;
    [type='button'] {
      appearance: none;
    }
  }
  body {
    color: #4a4a4a;
    font-size: 16px;
  }
  /**
   * Form elements don't inherit font settings.
   * https://stackoverflow.com/questions/26140050/why-is-font-family-not-inherited-in-button-tags-automatically
   */
  html,
  body,
  input,
  select,
  optgroup,
  textarea,
  button {
    font-weight: 400;
    font-family: 'Helvetica Now Display';
    font-feature-settings: 'kern';
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    overflow-x: hidden;
    text-rendering: optimizeLegibility;
  }
  
  @font-face {
    font-family: 'Helvetica Now Display';
    font-style: normal;
    font-weight: 500;
    font-display: swap;
    src: local('HelveticaNowDisplay Medium'),
      local('HelveticaNowDisplay-Medium'),
      url('https://assets.creditas.com/design-system-assets/fonts/1.0.0/helvetica-now-display/HelveticaNowDisplay-Medium.woff2')
        format('woff2');
    unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA,
      U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212,
      U+2215, U+FEFF, U+FFFD;
  }

  html,
  body,
  #root {
    height: 100%;
  }
`
